import { render, staticRenderFns } from "./editSeminaranmeldung.vue?vue&type=template&id=6d9a4d78&scoped=true&"
import script from "./editSeminaranmeldung.vue?vue&type=script&lang=js&"
export * from "./editSeminaranmeldung.vue?vue&type=script&lang=js&"
import style0 from "./editSeminaranmeldung.vue?vue&type=style&index=0&id=6d9a4d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a4d78",
  null
  
)

export default component.exports